import script from "./TeamsPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamsPicker.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__